var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "col col-sm-12 col-md-6 col-lg-4 teaser--deals",
      attrs: {
        href:
          _vm.baseUrl +
          (_vm.lang === "de" ? "/angebote/" : "/it/offerte/") +
          _vm.item.id +
          "/"
      }
    },
    [
      _c("figure", { staticClass: "figure figure--thumbnail" }, [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src: _vm.dealImage(_vm.item),
            width: "500",
            height: "340",
            loading: "lazy",
            alt: _vm.item.versionFullName ? _vm.item.versionFullName : ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "teaser__content--deals" }, [
        _c("p", { staticClass: "h4 teaser__title--deals font-weight-bold" }, [
          _vm._v(
            _vm._s(_vm.item.versionFullName ? _vm.item.versionFullName : "")
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "h4 font-color-secondary" }, [
          _vm._v(_vm._s(_vm.convertToCurrency(_vm.item.price)))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "title--small" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.vehicleProperties(_vm.item)) + "\n    "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }